export class TableViewCustomModel {
  public readonly id: number;

  public constructor(
    public tableViewName: string,
    public defaultView: boolean,
    public pivotMode: boolean,
    public columnState: string,
    public filterModel: string,
    public readonly tableViewArea: string,
  ) {}
}
